import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ComplexOptionCard = ({ title, onClick }) => (
  <Card className="booking-option-card my-4">
    <Card.Body>
      <Card.Title className="title-wrap">
        <h5 className="reset-text fw-bold mb-2 text-secondary">{title}</h5>
      </Card.Title>
      <div className="mt-3">
        <button
          type="button"
          onClick={onClick}
          className="btn btn-primary w-100"
        >
          Select
        </button>
      </div>
    </Card.Body>
  </Card>
);

ComplexOptionCard.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default ComplexOptionCard;
